/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { UpdateAdminCompetitionResponse, UpdateAdminCompetitionVars } from '../openapi-types.gen.js';

export type { UpdateAdminCompetitionResponse, UpdateAdminCompetitionVars } from '../openapi-types.gen.js';

export const useUpdateAdminCompetition = createMutationHook<UpdateAdminCompetitionVars, UpdateAdminCompetitionResponse, unknown>({
  specName: 'useUpdateAdminCompetition',
  path: '/v1/admin/competitions/{competitionId}',
  method: 'PUT',
  resolveUrl: (vars: UpdateAdminCompetitionVars) => `/v1/admin/competitions/${vars.competitionId}`,
  buildBody: (vars: UpdateAdminCompetitionVars) => ({ title: vars.title, subtitle: vars.subtitle, board: vars.board, metric: vars.metric, start: vars.start, end: vars.end, timezone: vars.timezone, bannerImageUrl: vars.bannerImageUrl, prizePoolD6: vars.prizePoolD6, rules: vars.rules }),
  parseResponse: (raw: unknown): UpdateAdminCompetitionResponse => raw as UpdateAdminCompetitionResponse,
  optimistic: [{
    queryKey: ['admin', 'detail'],
    apply: (prev: any, vars: UpdateAdminCompetitionVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
